<template>
    <div class="cursus-badge" :class="classes">
        {{ label }}
    </div>
</template>

<script>
    export default {
        props: {
            course: Object,
            action: Boolean,
        },
        computed: {
            classes() {
                return {
                    'border-0 text-reset bg-transparent': this.course.without_show_page,
                }
            },
            label() {
                if(this.action) {
                    if(this.course.registration_level === 'INSCRIPTION') {
                        return this.course.without_show_page ? 'Sur inscription' : `Je m’inscris`
                    }
                    if(this.course.registration_level === 'APPLICATION') {
                        return this.course.without_show_page ? 'Sur candidature' : `Je candidate`
                    }
                }
                return this.course.registration_label;
            }
        },
    }
</script>
